// extracted by mini-css-extract-plugin
export default {"eval-grid":"Evals-module__eval-grid--LLsni"};